// import { Input } from 'antd';
import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import { Button, Card, Form, Modal, Input } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import defaultPicture from '../../assets/images/default_picture.png';
import { resizeFile } from '../../common/uploadImage';
import {
  allTenantDevices,
  tenantDeviceInfos,
} from '../../pages/Dashboard/DashboardSlice';
import { allDevicesCustomer, saveDevice } from '../../pages/Device/DeviceSlice';

const ModalChangeAvatarDevice = ({ show, setShow, deviceId }) => {
  const dispatch = useDispatch();
  const typeAcc = useSelector((state) => state.profile.profile.authority);
  const token = localStorage.getItem('token');

  const [file, setFile] = useState();
  const tenantDevices = useSelector(allTenantDevices);

  const allDevices = useSelector(allDevicesCustomer);

  const currentDevice =
    typeAcc === 'TENANT_ADMIN'
      ? tenantDevices.data?.filter((item) => item.id.id === deviceId)[0]
      : allDevices.data?.filter((item) => item.id.id === deviceId)[0];

  const currentAvatar = currentDevice?.attributes.avatar;

  const [newName, setNewName] = useState('');
  const [latitude, setLatitude] = useState(currentDevice?.attributes?.latitude);
  const [longitude, setLongitude] = useState();


  useEffect(() => {
    currentDevice && setNewName(currentDevice.name);
    currentDevice && setLatitude(currentDevice?.attributes.latitude);
    currentDevice && setLongitude(currentDevice?.attributes.longitude);
    currentDevice && setFile(currentDevice.attributes.avatar);
  }, [currentDevice, show]);

  const handleClose = () => {
    setFile();
    setNewName(currentDevice?.name);
    setLatitude(currentDevice?.attributes?.latitude)
    setLongitude(currentDevice?.attributes?.longitude);
    setShow(false);
  };

  const handleSubmit = async () => {
    const name = newName;
    const deviceId = currentDevice.id.id;
    const deviceProfileId = currentDevice.deviceProfileId.id;
    const customerId = currentDevice.customerId.id;
    const label = currentDevice.label;
    const description = currentDevice.additionalInfo.description;
    await dispatch(
      saveDevice({
        token,
        deviceId,
        deviceProfileId,
        customerId,
        name,
        label,
        description,
        file,
        latitude,
        longitude
      })
    );

    await dispatch(tenantDeviceInfos({ token }));
    setShow(false);
    setFile();
  };

  const onChangeFile = async (file) => {
    try {
      const image = await resizeFile(file);
      setFile(image);
    } catch (err) {
      toast.error(err);
    }
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          {t('change-avatar-device') /* Đổi Hình Đại Diện Thiết Bị */}
        </Modal.Title>
      </Modal.Header>
      <Form>
        <Modal.Body>
          <>
            <Modal.Title as="h5"></Modal.Title>
            <Card.Img
              src={file ? file : currentAvatar ? currentAvatar : defaultPicture}
              style={{
                height: '300px',
                width: '100%',
                objectFit: 'cover',
              }}
            />
          </>
          <Form.Group className="position-relative mb-3">
            <Form.Label>{t('name-device')}</Form.Label>
            <Form.Control
              defaultValue={newName}
              value={newName}
              onChange={(e) => setNewName(e.target.value)}
            />
            <Form.Label>{t('avatar')}</Form.Label>
            <Form.Control
              type="file"
              accept="image/*"
              onChange={(e) => onChangeFile(e.target.files[0])}
            />
            <h4 style={{ marginTop: '10px', marginBottom: '-10px' }}>{t('location')}</h4>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div
                style={{ marginRight: '10px' }}>
                <Form.Label>{t('latitude')}</Form.Label>
                <Form.Control
                  type='number'
                  defaultValue={latitude}
                  value={latitude}
                  onChange={(e) => setLatitude(e.target.value)}
                />
              </div>
              <div>
                <Form.Label>{t('longitude')}</Form.Label>
                <Form.Control
                  type='number'
                  defaultValue={longitude}
                  value={longitude}
                  onChange={(e) => setLongitude(e.target.value)}
                />
              </div>
            </div>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {t('close')}
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            {t('save')}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ModalChangeAvatarDevice;
